/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ErrorResponse, I18NLanguageStatusDTO } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class I18NLanguages<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns the maintenance status, current entry count, and most recent import-protocol entry for every language
   *
   * @tags I18n Languages
   * @name GetLanguageStatuses
   * @summary Get language statuses
   * @request GET:/api/admin/i18n/languages
   * @secure
   */
  getLanguageStatuses = (params: RequestParams = {}) =>
    this.request<I18NLanguageStatusDTO[], ErrorResponse>({
      path: `/api/admin/i18n/languages`,
      method: "GET",
      secure: true,
      ...params,
    });
}
